import Svg, { Path } from 'react-native-svg'

export const DeleteIcon = ({ height = 24, width = 24, color = '#E30513' }) => {
  return (
    <Svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} fill="none">
      <Path
        fill={color}
        d="M20 6h-2V5a3 3 0 0 0-3-3H9a3 3 0 0 0-3 3v1H4a1 1 0 0 0 0 2h1v11a3 3 0 0 0 3 3h8a3 3 0 0 0 3-3V8h1a1 1 0 1 0 0-2ZM9 18a1 1 0 1 1-2 0v-7a1 1 0 1 1 2 0v7Zm4 0a1 1 0 0 1-2 0v-7a1 1 0 0 1 2 0v7Zm4 0a1 1 0 0 1-2 0v-7a1 1 0 0 1 2 0v7ZM8 5a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v1H8V5Z"
      />
    </Svg>
  )
}
